import { useEffect, useState } from 'react'
import { accountResume } from "../../Api";
import { setTitlePage } from "../../Functions";

const AccountResume = () => {

  const [state, setState] = useState<any>({
      loading: false,
  });

  const loadData = async () => {
    setState({
      loading: true,
    });
    const _response:any = await accountResume({});
    if (_response.status) {
      setState({
        trimestral: _response.data.trimestral,
        titulo: _response.data.titulo,
        loading: false,
      });
    }
  }

  useEffect(() => {
    setTitlePage('Resumen de Cuentas');
    loadData();
  }, [])

  return (
    <>
      <div className="amount-not-with-drawn">
        {state?.trimestral === undefined ? (
          <div className="loader p-3 text-center">
            {/* <Spinner style={{ width: "6rem", height: "6rem" }} /> */}
            <p className="text-center">Cargando...</p>
          </div>
        ) : (
          <div className='row card'>
            <div className="col-12 card-body table-responsive">
              <table className="table table-row-bordered table-payment-datail">
                <thead className='fs-6'>
                  <tr>
                    <th></th>
                    {state?.titulo?.map((item:any, index:any) => (
                        <th key={index} style={{textAlign: 'right', fontWeight: 'bold', textTransform: 'lowercase'}}>
                          {Object.values(item)}
                        </th>
                      ))}
                  </tr>
                </thead>
                <tbody className='fs-6 text-gray-800'>
                {state?.trimestral?.map((item:any, index:any) => (
                    <tr key={index}>
                      <td className="text-left pt-7 pb-3">
                        <span className="p-3 fw-bold" style={{width: "fit-content"}}>
                        {item.Glosa}
                        </span>
                      </td>
                      <td className="text-right" style={{textAlign: 'right'}}>
                        {item.Glosa !== '% PAGOS' ? '$ ' + new Intl.NumberFormat("de-DE").format(item.Tramo_1) : item.Tramo_1 + ' %'}
                      </td>
                      <td className="text-right" style={{textAlign: 'right'}}>
                        {item.Glosa !== '% PAGOS' ? '$ ' + new Intl.NumberFormat("de-DE").format(item.Tramo_2) : item.Tramo_2 + ' %'}
                      </td>
                      <td className="text-right" style={{textAlign: 'right'}}>
                        {item.Glosa !== '% PAGOS' ? '$ ' + new Intl.NumberFormat("de-DE").format(item.Tramo_3) : item.Tramo_3 + ' %'}
                      </td>
                      <td className="text-right" style={{textAlign: 'right'}}>
                        {item.Glosa !== '% PAGOS' ? '$ ' + new Intl.NumberFormat("de-DE").format(item.Tramo_4) : item.Tramo_4 + ' %'}
                      </td>
                    </tr>
                  ))}
                  </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </>
  )
}

export default AccountResume